var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F15B40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8.1c7.015 0 12.7 5.685 12.7 12.7s-5.685 12.7-12.7 12.7S.1 19.815.1 12.8 5.785.1 12.8.1zm0 23.81c6.14 0 11.11-4.97 11.11-11.11S18.94 1.69 12.8 1.69 1.69 6.66 1.69 12.8 6.66 23.91 12.8 23.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.895 15.131a.847.847 0 01-.845-.845V7.44c0-.465.38-.845.845-.845.466 0 .845.38.845.845v6.846c0 .465-.38.845-.845.845zm-.002 4.274a1.143 1.143 0 110-2.286 1.143 1.143 0 010 2.286z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/Ic_error.df26663a4c3bfefafd89c0735edff514.svg";
export { ForwardRef as ReactComponent };